/**
 * Hero Slider Component
 */

document.addEventListener('DOMContentLoaded', function() {
    const heroSlider = document.querySelector('.hero-slider');
    
    // Função para aplicar imagem mobile se estiver em mobile
    function applyMobileImages() {
        const isMobile = window.innerWidth <= 768;
        const slides = document.querySelectorAll('.hero-banner__slide[data-mobile-image]');
        
        slides.forEach(slide => {
            const mobileImage = slide.getAttribute('data-mobile-image');
            
            if (isMobile && mobileImage) {
                // Aplicar imagem mobile no mobile
                slide.style.backgroundImage = `url('${mobileImage}')`;
            } else if (!isMobile) {
                // Restaurar imagem desktop quando não estiver em mobile
                const desktopImage = slide.getAttribute('data-desktop-image');
                if (desktopImage) {
                    slide.style.backgroundImage = `url('${desktopImage}')`;
                }
            }
        });
    }
    
    // Aplicar imagens mobile na carga inicial
    applyMobileImages();
    
    // Aplicar imagens mobile quando a janela for redimensionada
    let resizeTimeout;
    window.addEventListener('resize', function() {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(applyMobileImages, 100);
    });
    
    if (heroSlider && typeof jQuery !== 'undefined' && jQuery.fn.slick) {
        // Salvar imagem desktop original antes de inicializar o slider
        const slides = document.querySelectorAll('.hero-banner__slide');
        slides.forEach(slide => {
            const currentBg = slide.style.backgroundImage || window.getComputedStyle(slide).backgroundImage;
            if (currentBg && currentBg !== 'none') {
                slide.setAttribute('data-desktop-image', currentBg.replace(/url\(['"]?(.*?)['"]?\)/i, '$1'));
            }
        });
        
        jQuery(heroSlider).slick({
            dots: true,
            infinite: true,
            speed: 500,
            fade: true,
            cssEase: 'linear',
            autoplay: true,
            autoplaySpeed: 5000,
            arrows: false,
            pauseOnHover: true,
            adaptiveHeight: false,
            slidesToShow: 1,
            slidesToScroll: 1,
        });
        
        // Reaplicar imagens mobile após o slider ser inicializado
        setTimeout(applyMobileImages, 100);
    }
});

